/*******************************************************************************
 * @ngdoc    object
 * @module   makeDeposit
 * @name     csm.books.MakeDeposit.Data.type:DepositReceiptItem
 * @constructor
 * @param {object=} item  Item info read from database.
 * @description
 * Represents a receipt that is part of a deposit or an undeposited receipt.
 *******************************************************************************/
/* @ngInject */ export function runDepositReceiptItemData(Data) {
  Data.DepositReceiptItem = function (item) {
    var rv = Object.assign(
      Object.create(Data.DepositReceiptItem.prototype),
      item || {}
    );
    rv.payments = rv.payments.map(function (p) {
      return new Data.DepositReceiptPaymentItem(p);
    });
    rv.saleItemTotals = rv.saleItemTotals.map(function (s) {
      return new Data.DepositReceiptSalesItem(s);
    });
    return rv;
  };

  Data.DepositReceiptItem.prototype = {
    id: NaN, // Receipt ID
    receiptNumber: null, // Receipt Number
    receiptFrom: null, // Receipt From
    amount: NaN, // Receipt Amount
    payments: [], // Receipt Payments
    saleItemTotals: [] // Sale Item Totals
  };
};
